import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Button from 'components/atoms/Buttons/Button/Button';

const StyledActionButton = styled(Button)`
  ${ComponentStyles}
`;

StyledActionButton.propTypes = {
  theme: PropTypes.object
};

export default StyledActionButton;
